import { observable, computed, makeAutoObservable } from 'mobx';
import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';
import { reduxImmutableHash } from './utils/reduxImmutableHash';
import { ReduxRawState } from './utils/ReduxRawState';

const UserDataIO = t.interface({
    authenticated: t.boolean,
    login: t.union([
        t.undefined,
        t.null,
        t.interface({
            errors: t.union([
                t.undefined,
                t.null,
                t.interface({
                    password: t.string,
                }),
            ]),
            state: t.union([t.undefined, t.null, t.string]),
        }),
    ]),
});

const isUserData = createGuard(UserDataIO);

type UserDataType = t.TypeOf<typeof UserDataIO>;

export class ReduxLoginState {
    @observable private userData: UserDataType | null = null;

    public constructor(reduxStore: ReduxRawState) {
        reduxImmutableHash(
            reduxStore,
            (state: Record<string, unknown>): unknown => {
                return state.user;
            },
            (data: unknown): void => {
                if (data === undefined) {
                    return;
                }

                if (isUserData(data)) {
                    this.userData = data;
                } else {
                    console.error('ReduxLoginState -> cannot decode data', data);
                }
            }
        );
        makeAutoObservable(this);
    }

    @computed public get isLoggedIn(): boolean | null {
        return this.userData?.authenticated ?? null;
    }

    @computed public get loginError(): string | null {
        return this.userData?.login?.errors?.password ?? null;
    }

    @computed public get loginStatus(): string {
        return this.userData?.login?.state ?? '';
    }
}
